import "../styles/home.css";

export function Home() {
    return (
        <div>
            <h1>
                Hey, I'm <b>Ari</b>!
            </h1>
            <p>I love writing code that looks nice, runs fast, and makes fun</p>

            <div className="info-grid">
                <div className="info-card">
                    <h3>My skills and interests</h3>
                    <p>
                        <b>Graphics</b>
                        <br />
                        OpenGL, GLSL, CUDA, Three.js
                        <br />
                        <b>Game Engines</b>
                        <br />
                        Godot, Unity
                        <br />
                        <b>Backend</b>
                        <br />
                        C/C++, Java, Spring, data mesh
                    </p>
                </div>

                <div className="info-card">
                    <h3>My current work</h3>
                    <p>
                        Shipping features for 30k+ students on the CU student
                        portal, training quantized <b>ML models</b> for medical
                        imaging, and competing in game jams
                    </p>
                </div>

                <div className="info-card">
                    <h3>My education</h3>
                    <p>
                        Graduating <b>magna cum laude</b> from CU Boulder
                        <br />
                        BS in <b>Computer Science</b>, minors in{" "}
                        <b>Computer Engineering</b> and <b>German Studies</b>.
                    </p>
                </div>

                <div className="info-card">
                    <h3>Other</h3>
                    <p>
                        Based in <b>Colorado</b>. Always up for talking about
                        graphics programming, high altitude baking, or puzzles!
                    </p>
                </div>
            </div>
        </div>
    );
}